import { ReactLenis } from "lenis/react";
import "lenis/dist/lenis.css";
import { LangProvider } from "@/i18n";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import About from "@/components/About";
import Services from "@/components/Services";
import Management from "@/components/Management";
import Cleaning from "@/components/Cleaning";
import Territory from "@/components/Territory";
import PrivateServices from "@/components/PrivateServices";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

const NOISE =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='160' height='160' filter='url(%23n)' opacity='0.55'/%3E%3C/svg%3E";

export default function App() {
  return (
    <LangProvider>
      <ReactLenis root options={{ lerp: 0.09 }}>
        <div className="bg-ivory font-sans text-navy antialiased">
          <div
            aria-hidden
            className="pointer-events-none fixed inset-0 z-[70] opacity-[0.05]"
            style={{ backgroundImage: `url("${NOISE}")` }}
          />
          <Navbar />
          <main>
            <Hero />
            <EditorialMarquee />
            <About />
            <Services />
            <Management />
            <Cleaning />
            <Territory />
            <PrivateServices />
            <Contact />
          </main>
          <Footer />
          <WhatsAppFloat />
        </div>
      </ReactLenis>
    </LangProvider>
  );
}
